/**
 * Program: Mixin for Multilingual Processing
 * Author: SDL
 * Description: Mixin for Multilingual Processing
 */
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      locale: 'getLocale',
    }),
  },
  methods: {
    getLabel({ labelJson, label }) {
      if (labelJson && labelJson[this.locale] !== undefined && labelJson[this.locale].trim() !== '') {
        return labelJson[this.locale];
      }
      return label;
    },
    getLabelByLang({ labelJson, label }, lang) {
      if (labelJson && labelJson[lang] !== undefined && labelJson[lang].trim() !== '') {
        return labelJson[lang];
      }
      return label;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/SDLLocale.js